









import { Vue, Component, Emit, Prop, Watch, Model } from 'vue-property-decorator'

@Component
export default class WaterFall extends Vue {
  @Prop() list!: any[]
  @Prop({ default: 2 }) readonly col!: number

  displayWrapRef: any = null

  @Watch('list')
  listChange() {
    // 待组件渲染完成且图片加载一段时间后再计算高度组装瀑布流
    this.$nextTick(() => {
      setTimeout(() => {
        this.layout()
      }, 100)
    })
  }

  mounted() {
    this.displayWrapRef = this.$refs.displayWrap
  }

  layout() {
    this.moveEle()
  }
  moveEle() {
    const tempChildren = this.$refs.temp && (this.$refs.temp as any).children
    if (tempChildren && tempChildren.length) {
      // const short = [...this.displayWrapRef.children]
      //   .map((x, i) => ({ h: x.offsetHeight, i }))
      //   .reduce((prev, next) => {
      //     return prev.h <= next.h ? prev : next
      //   })
      const displayChildren = [...this.displayWrapRef.children]
      const displayChildrenHeight = displayChildren.map((c, i) => ({
        h: c.offsetHeight,
        i,
      }))
      const short = displayChildrenHeight.reduce((prev, next) => {
        return prev.h <= next.h ? prev : next
      })
      this.displayWrapRef.children[short.i].appendChild(tempChildren[0])
      this.moveEle()
    }
  }
}
